<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <form-item-group
      title="Swap"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.SWAP.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.SWAP.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.SWAP.ITEM"
      v-model="item.swap"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`swap.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.swap[index].image_url"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`swap.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.swap[index].landing_page"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { SWAP } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        swap: [...Array(SWAP.MIN_NUM)].map(() => _.cloneDeep(SWAP.ITEM)),
      },
      limited_size: {
        image: {
          width: {
            max: 300,
            min: 300,
          },
          height: {
            max: 250,
            min: 250,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.swap = _.map(row.swap, (swap) => {
        return {
          image_url: decodeURI(swap.image_url),
          landing_page: decodeURI(swap.landing_page),
        };
      });
    },
    async getData(setObj) {
      setObj.swap = _.map(this.item.swap, (swap) => {
        return {
          image_url: swap.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          landing_page: swap.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });

      return setObj;
    },
  },
};
</script>

<style></style>
